import { Box } from "@mui/material";
import { GridPaginationModel, GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import CustomDataGridV2 from "../../../../../../../components/CustomDataGridV2";
import Flex from "../../../../../../../components/Flex";
import RenderWithTooltip from "../../../../../../../components/RenderWithTooltip";
import Text from "../../../../../../../components/Text";
import StatusChip from "../../../../../../../components/StatusChip";
import ActionMenu from "../../../../../../../components/app/ActionMenu";
// import { CHART_COLORS } from "../../../../../../../components/app/provider/patient/chart";
import useDisclosure from "../../../../../../../hooks/use-disclosure";
import { useGetReferralById } from "../../../../../../../queries/collaboration/referral/use-get-referral-by-uuid";
import { NonNullableDate } from "../../../../../../../utils/date-time-utility";
import {
  // DEFAULT_FONTSIZE,
  DEFAULT_VALUE_LABEL_LIST,
  applyDefaultColumnSettings,
  getXtenantId,
  replaceUnderScoreAddSpace,
  transformMultiSelectFrontEndVal,
} from "../../../../../../../utils/utils";
import UpsertReferral from "../../../../collabration/referrals/UpsertReferral";
import ViewReferral from "../../../../collabration/referrals/ViewReferral";
import { useArchiveReferral } from "../../../../../../../queries/collaboration/referral/use-referral-archive";
import { useArchiveState } from "../../../../../../../hooks/useArchiveState";
import DeleteModal from "../../../../../../../components/app/DeleteModal";
import { useReduceDisclosure } from "../../../../../../../hooks/use-reduce-disclosure";
import ChangeReferralStatus from "../../../../collabration/referrals/ChangeReferralStatus";
import NewAppointment from "../../../../scheduling/appointment/NewAppointment";
import {
  getObjectFromList,
  PRIORITY_MAPPING,
} from "../../../../collabration/collaboration-referral-constant";

const MINIMIZED_REFERRAL_FIELDS = [
  "referralFrom",
  "referralTo",
  "referralIn",
  "referralStatus",
  "action",
];

const PatientReferralNew = ({
  referral,
  isFetching,
  refetch,
  pagination,
  setPagination,
  referralGridSorting,
  setReferralGridSorting,
}: {
  referral?: any;
  isFetching: boolean;
  refetch: () => void;
  pagination: GridPaginationModel;
  setPagination: (pagination: GridPaginationModel) => void;
  referralGridSorting: GridSortItem[];
  setReferralGridSorting: (referralGridSorting: GridSortItem[]) => void;
}) => {
  const isVisitNotePage = window.location.pathname.includes("/visit-note");
  const [appointmentDisclosure, changeReferralStatusDisclosureHost] =
    useReduceDisclosure(3);
  const [archive, setArchive] = useState(false);
  const { mutateAsync: archiveMutation } = useArchiveReferral();
  const { deleteDisc, archiveHandler } = useArchiveState(archiveMutation);

  const [referralId, setReferralId] = useState("");
  const { data: referralData } = useGetReferralById({
    referralId: referralId,
    xTENANTID: getXtenantId() as string,
  });

  const data = referralData?.data;

  const viewReferralDisclosureHost = useDisclosure();
  const referralDisclosureHost = useDisclosure(false, {
    onClose: () => {
      setReferralId("");
    },
  });

  const COLUMNS = applyDefaultColumnSettings(
    [
      {
        field: "referralFrom",
        headerName: "Referral From",
        minWidth: 120,
        flex: 0.8,
        renderCell: ({ row }) => {
          return (
            <Flex gap={"10px"}>
              <Box>
                <Text isTabletext marginBottom={"1px"}>
                  {`${row?.referralFromName ?? ""}`}
                </Text>
              </Box>
            </Flex>
          );
        },
      },
      {
        field: "referralTo",
        headerName: "Referral To",
        minWidth: 100,
        flex: 0.65,
        renderCell: ({ row }) => {
          return (
            <Flex gap={"10px"}>
              <Box>
                <Text isTabletext marginBottom={"1px"}>
                  {`${row?.referralToName ?? ""}`}
                </Text>
              </Box>
            </Flex>
          );
        },
      },
      {
        field: "referralIn",
        headerName: "Referral Type",
        minWidth: 80,
        flex: 0.65,
        renderCell: ({ row }: any) => (
          <StatusChip
            label={row?.referralIn ? "In" : "Out"}
            variant={row?.referralIn ? "info" : "neutral"}
          />
        ),
      },
      {
        field: "referral_date",
        headerName: "Referral Date",
        minWidth: 90,
        flex: 0.65,
        renderCell: ({ row }: any) => (
          <Text isTabletext>{NonNullableDate(row?.referralDate)}</Text>
        ),
      },
      {
        field: "referral_priority",
        headerName: "Priority",
        minWidth: 70,
        flex: 0.45,
        renderCell: ({ row }: { row: any }) => {
          const priorityConfig =
            PRIORITY_MAPPING[
              row?.referralPriority as keyof typeof PRIORITY_MAPPING
            ];

          return (
            <Text
              isTabletext
              // style={{ color: priorityConfig?.color || "black" }}
            >
              {priorityConfig?.label ?? "-"}
            </Text>
          );
        },
      },
      {
        field: "description",
        headerName: "Response Description",
        minWidth: 150,
        flex: 1.5,
        renderCell: ({ value }) => <RenderWithTooltip value={value} />,
      },
      {
        field: "referralStatus",
        headerName: "Response Status",
        minWidth: 100,
        flex: 0.95,
        renderCell: ({ row }) => (
          <>
            {row?.referralStatus ? (
              // <Chip
              //   size="small"
              //   label={
              //     <Text isTabletext>
              //       <Flex gap={1} alignItems={"center"}>
              //         {replaceUnderScoreAddSpace(
              //           row?.referralStatus.toLowerCase()
              //         )}
              //       </Flex>
              //     </Text>
              //   }
              //   sx={{
              //     color: row?.status === "COMPLETED" ? "green" : "black",
              //     bgcolor:
              //       row?.status === "PENDING" ? "lightgray" : "lightgray",
              //   }}
              // />
              <Text isTabletext>
                {replaceUnderScoreAddSpace(row?.referralStatus.toLowerCase())}
              </Text>
            ) : (
              ""
            )}
          </>
        ),
      },
      {
        field: "action",
        headerName: "Actions",
        minWidth: 45,
        flex: 0.25,
        renderCell: ({ row }: any) => (
          <ActionMenu
            options={[
              { value: "view", label: "View" },
              { value: "edit", label: "Edit" },
              // { value: "reassign", label: "Reassign" },
              {
                value: "archive",
                label: row?.archive ? "Unarchive" : "Archive",
              },
              ...(row?.referralIn === true
                ? [{ value: "book-appointment", label: "Book Appointment" }]
                : []),
              {
                value: "change-status",
                label: "Change Status",
              },
            ]}
            onActionClick={(action: any) => {
              if (action === "edit") {
                setReferralId(row?.uuid);
                referralDisclosureHost.open();
              } else if (action == "view")
                viewReferralDisclosureHost.open(row?.uuid);
              else if (action == "archive") {
                setArchive(row?.archive);
                deleteDisc.open(row?.uuid);
              } else if (action == "change-status") {
                changeReferralStatusDisclosureHost.open(row?.uuid);
              } else if (action == "book-appointment") {
                appointmentDisclosure.open({
                  value: row?.patientUuid,
                  label: row?.patientName,
                  birthDate: row?.patientDob,
                });
              }
            }}
          />
        ),
      },
    ],
    ["patientName", "referral_date", "referral_priority"]
  );

  return (
    <>
      <DeleteModal
        w="380px"
        open={deleteDisc.opened}
        onClose={deleteDisc.close}
        id={deleteDisc.deleteId}
        onConfirmation={(id) =>
          archiveHandler(!archive, id).then((res) => {
            refetch();
            return res;
          })
        }
        content={`You want to ${
          archive ? "unarchive" : "archive"
        } this Referral`}
      />

      {referralDisclosureHost.opened && (
        <UpsertReferral
          title="Update Referral"
          hideAddPatient
          disclosureHost={referralDisclosureHost}
          prefillData={{
            ...data,
            patient: getObjectFromList(data?.patient),
            referralFrom: getObjectFromList(data?.referralFrom),
            referralTo: getObjectFromList(data?.referralTo),
            referralSpecialities: getObjectFromList(data?.referralSpecialities),
            referralDiagnosisCode: transformMultiSelectFrontEndVal(
              DEFAULT_VALUE_LABEL_LIST,
              data?.referralDiagnosisCode
            ),
            referralDocument: data?.referralDocument ?? undefined,
            referralDocumentName: data?.referralDocumentName ?? undefined,
            patientInsurance: data?.patientInsurance
              ? {
                  value: data?.patientInsurance?.uuid,
                  label: data?.patientInsurance?.insurancePayer?.payerName,
                }
              : undefined,
            referralAppointment: getObjectFromList(data?.referralAppointment),
          }}
        />
      )}

      {changeReferralStatusDisclosureHost.opened && (
        <ChangeReferralStatus
          open={changeReferralStatusDisclosureHost.opened}
          onClose={changeReferralStatusDisclosureHost.close}
          disclosureHost={changeReferralStatusDisclosureHost}
        />
      )}
      {appointmentDisclosure.opened && (
        <NewAppointment
          prefillPatientData={appointmentDisclosure?.data}
          opened={appointmentDisclosure.opened}
          onClose={appointmentDisclosure.close}
        />
      )}
      {viewReferralDisclosureHost.opened && (
        <ViewReferral disclosureHost={viewReferralDisclosureHost} />
      )}
      <CustomDataGridV2
        loading={isFetching}
        rows={referral?.data.content || []}
        rowCount={referral?.data?.page?.totalElements ?? 10}
        getRowId={(row: any) => row.uuid}
        columns={
          isVisitNotePage
            ? COLUMNS.filter((col: any) =>
                MINIMIZED_REFERRAL_FIELDS.includes(col.field)
              )
            : COLUMNS
        }
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
        onSortModelChange={setReferralGridSorting}
        sortModel={referralGridSorting}
      />
    </>
  );
};

export default PatientReferralNew;
